import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FilterModel } from '@ui/shared/util-filter';
import { FilterState } from '@ui/shared/domain-filter';
import { Observable, map } from 'rxjs';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-reset-filter-container',
    templateUrl: './reset-filter-container.component.html',
    styleUrls: ['./reset-filter-container.component.scss'],
    standalone: false,
})
export class ResetFilterContainerComponent {
    public readonly filters$: Observable<Array<FilterModel>>;

    constructor(
        private readonly _activeFilterService: FilterState,
    ) {
        this.filters$ = _activeFilterService.activeFilters$
            .pipe(
                map(activeFilters => Array.from(activeFilters.values())),
            );
    }

    public resetFilter(filter: FilterModel): void {
        this._activeFilterService.setActiveFilter(FilterModel.from({ key: filter.key, values: [], title: filter.title }));
    }

    public resetAllFilters(): void {
        this._activeFilterService.resetActiveFilters();
    }
}
